import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { DeviceService, ToastrQueueService, UserService } from '@frontend/vanilla/core';
import { LetDirective } from '@ngrx/component';
import { ToastrService } from 'ngx-toastr';
import { Observable, map } from 'rxjs';

import { OffersConstants } from '../common-constants/offers-constants';
import { LoadOffersApiService } from '../offers-service/load-offers.service';

@Component({
    selector: 'no-offer-message',
    templateUrl: 'no-offers.component.html',
    styleUrls: ['./no-offers.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LetDirective],
})
export class NoOffersComponent implements OnInit, OnDestroy {
    @Input() customMessage: string;
    @Input() areGroupedOffersEmpty: boolean = false;
    message$: Observable<any>;

    constructor(
        public userService: UserService,
        private loadOffersApiService: LoadOffersApiService,
        public deviceService: DeviceService,
        private toast: ToastrQueueService,
        private toastrService: ToastrService,
    ) {}

    ngOnInit() {
        this.message$ = this.loadOffersApiService.clientContentMessages$.pipe(
            map((clientContentMessages) => {
                if (this.customMessage) {
                    return {
                        noOfferMessage: this.customMessage,
                    };
                }
                return {
                    noOfferMessage:
                        (this.userService.isAuthenticated
                            ? this.areGroupedOffersEmpty
                                ? clientContentMessages[OffersConstants.NoFilteredOffers]
                                : clientContentMessages[OffersConstants.NoMyOffers]
                            : clientContentMessages[OffersConstants.NoOffersWithoutLogin]) ?? '',
                    refresh: clientContentMessages[OffersConstants.Refresh],
                };
            }),
        );
        if (this.userService.isAuthenticated && this.areGroupedOffersEmpty && !this.deviceService.isMobile) {
            this.toast.add('nofilteredoffers');
        }
    }

    getOffers() {
        this.loadOffersApiService.loadOffers([]);
    }

    ngOnDestroy() {
        this.toastrService.clear();
    }
}
